module.exports = __webpack_public_path__ + "img/04李京楠.912e4aeb.png";